import { useCallback, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import axios from 'axios';
import { gdprDataSlice } from '../../store/gdprData/gdprData.slice';
import { GAService } from '../../services/GAService';
import { OptanonService } from '../../services/optanon.service';
import { useGAEventMeta } from '../../hooks/useGAEventMeta.hook';
import initSegment from '@finanzcheck/one-segment';
import { ENVIRONMENTS } from '../../../types/environments';
import { KNOWN_QUERY_PARAMS } from '../../../server/services/QueryInputService/QueryInputService.types';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { useScript } from '../../hooks/useScript.hook';
function useOneSegment() {
    var _a;
    var ONE_TRUST_SCRIPT_ATTRS = (_a = {
            id: 'init-one-segment',
            strategy: 'afterInteractive'
        },
        _a['data-domain-script'] = typeof window !== 'undefined' && window.ENV
            ? window.ENV.oneTrustDataDomainScript
            : '',
        _a);
    var oneTrustScriptIsLoaded = useScript('https://cdn.cookielaw.org/scripttemplates/otSDKStub.js', ONE_TRUST_SCRIPT_ATTRS).isLoaded;
    useEffect(function () {
        if (window && window.ENV) {
            var _a = window.ENV, environment = _a.environment, segmentHost = _a.segmentHost, segmentApiKey = _a.segmentApiKey, sessionCookieDomain = _a.sessionCookieDomain;
            initSegment(segmentApiKey, {
                debug: environment !== ENVIRONMENTS.PRODUCTION,
                segmentHost: segmentHost,
                sessionCookieDomain: sessionCookieDomain,
                teamName: 'mortgage',
                initialPageTrack: false,
            });
        }
    }, [oneTrustScriptIsLoaded]);
}
function useGAInitialized() {
    var gaEventMeta = useGAEventMeta();
    var dispatch = useDispatch();
    var handleConsentEvaluation = useCallback(function () {
        var grantedCategories = OptanonService.parseGrantedCategories();
        GAService.init(grantedCategories);
        dispatch(gdprDataSlice.actions.setGrantedCategories(grantedCategories));
        GAService.onPageEnter(gaEventMeta);
        if (grantedCategories !== null) {
            // eslint-disable-next-line no-console
            console.log(Object.values(grantedCategories));
        }
    }, []);
    useEffect(function () {
        window.addEventListener('OneSegmentConsentEvaluated', handleConsentEvaluation);
        return function onTeardown() {
            window.removeEventListener('OneSegmentConsentEvaluated', handleConsentEvaluation);
        };
    }, []);
}
var mapStateToProps = function (state) { return ({
    isBlockingIgnored: initialDataSlice.selectors.getIsBlockingIgnored(state),
}); };
var mapDispatchToProps = function () { return ({}); };
function RawAppStartObserver(_a) {
    var isBlockingIgnored = _a.isBlockingIgnored;
    useOneSegment();
    useGAInitialized();
    useEffect(function () {
        axios.defaults.params = {};
        if (isBlockingIgnored) {
            axios.defaults.params[KNOWN_QUERY_PARAMS['IS_BLOCKING_IGNORED']] = '1';
        }
    }, [isBlockingIgnored]);
    return null;
}
export var AppStartObserver = connect(mapStateToProps, mapDispatchToProps)(RawAppStartObserver);
